import { render, staticRenderFns } from "./swipeCom.vue?vue&type=template&id=c0f3e642&scoped=true&"
import script from "./swipeCom.vue?vue&type=script&lang=js&"
export * from "./swipeCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f3e642",
  null
  
)

export default component.exports